import script from "./DialogUVA.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogUVA.vue?vue&type=script&setup=true&lang=ts"

import "./DialogUVA.vue?vue&type=style&index=0&id=e2b8a1b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2b8a1b4"]])

export default __exports__